import React, { Component } from "react";
import { browserHistory, Link } from "react-router";
import PropTypes from "prop-types";
import moment from "moment";
import LoadingIndicatorHeader from "../loading-indicator/loading-indicator-header";
import RuleDetailExceptions from "./rule-detail-exceptions";
import RuleDetailSource from "./rule-detail-source";
import RuleDetailSchedule from "./rule-detail-schedule";
import InaccessibleLink from "../shim/inaccessible-link";
import Tooltip from "../tooltip/tooltip";
import util from "../util/util";

const jQuery = window.jQuery;

export default class RuleDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: Number(this.props.params.id), // id used to go get rule data;
      loaded: false // has Ajax data loaded yet;
    };
  }

  componentDidMount() {
    this.mounted = true;

    this.getRule();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    if (this.state.loaded === false) {
      return <LoadingIndicatorHeader />;
    } else {
      const isRuleLive = this.state.state === "live";
      const tooltipMessage =
        "Only expired rules can be deleted.<br />" +
        "Click the 'Expire Rule Now' button<br />" +
        "to expire this rule.";
      return (
        <div className="rule-detail">
          <div className="row">
            <div className="col-xs-7 col-sm-8">
              <h4 className="page__title">{this.state.name}</h4>
            </div>
            <div className="col-xs-5 col-sm-4">
              <p className="page__actions">
                <Link
                  to={util.returnRuleFormUrl(this.state.id)}
                  className="btn btn-primary"
                >
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                  Edit Rule
                </Link>
                <span
                  data-tip={isRuleLive ? tooltipMessage : ""}
                  data-for="ruleDetailDeleteRule"
                >
                  <button
                    className="btn btn-danger"
                    onClick={
                      isRuleLive
                        ? () => {
                            return "";
                          }
                        : () => this.deleteRule()
                    }
                    disabled={isRuleLive ? true : ""}
                  >
                    <i className="fa fa-trash-o" aria-hidden="true"></i>
                    Delete Rule
                  </button>
                </span>
              </p>
              {isRuleLive && <Tooltip id="ruleDetailDeleteRule" />}
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-6">
              <h4 className="page__header">Rule Name</h4>
              <p>{this.state.name}</p>
            </div>
            <div className="col-sm-6">
              <h4 className="page__header">Rule Created</h4>
              <p>
                {moment(this.state.created).format(util.dateFormatHumanLong)}
              </p>
            </div>
          </div>
          &nbsp;
          <div className="row">
            <div className="col-sm-6">
              <h4 className="page__header">Last Changed By</h4>
              <p>
                <em>Not available in the API (yet).</em>
              </p>
            </div>
            <div className="col-sm-6">
              <h4 className="page__header">Change Log</h4>
              <p>
                <Link
                  to={util.returnChangeLogDetailUrl(
                    `rules.rule`,
                    this.state.id
                  )}
                >
                  View Change Log
                </Link>
              </p>
            </div>
          </div>
          <hr />
          <RuleDetailSource
            campaign={this.state.campaign}
            pod={this.state.pod}
          />
          <hr />
          <RuleDetailSchedule
            endDate={this.state.endDate}
            frequency={this.state.frequency}
            rule={this.state.rule}
            startDate={this.state.startDate}
            timeslots={this.state.timeslots}
            shows={this.state.shows}
          />
          {this.state.state !== `expired` ? (
            <p className="page__actions">
              <InaccessibleLink
                id="rule-detail__button--expire"
                className="btn btn-danger"
                data-loading-text="<i class='fa fa-spinner fa-spin'></i> Expiring Rule Now"
                onClick={() => this.expireRule()}
              >
                <i className="fa fa-calendar-times-o" aria-hidden="true"></i>
                Expire Rule Now
              </InaccessibleLink>
            </p>
          ) : null}
          <hr className="spacer" />
          <RuleDetailExceptions
            exceptions={this.state.exceptions || false}
            onClickDeleteException={id => this.deleteException(id)}
          />
        </div>
      );
    }
  }

  // get the rule data to display;
  getRule(callback = null) {
    util.getRule(this.state.id).then(data => {
      setTimeout(() => {
        this.mounted &&
          this.setState(
            {
              campaign: data.campaign,
              created: data.created,
              endDate: data.end_date,
              exceptions: data.exceptions.length ? data.exceptions : false,
              frequency: data.frequency,
              loaded: true,
              name: data.name,
              pod: data.pod,
              rule: {
                bymonthday: data.rule.bymonthday,
                byweekday: data.rule.byweekday,
                interval: data.rule.interval
              },
              sourceType: data.pod ? `pod` : `campaign`,
              startDate: data.start_date,
              state: data.state.toLowerCase(),
              timeslots: data.timeslots,
              shows: data.shows
            },
            () => {
              // if a callback exists (hide modal), fire it;
              if (callback) {
                callback();
              }
            }
          );
      }, util.delayDetail);
    });
  }

  // call the delete rule endpoint
  deleteRule() {
    const title = `Delete Rule`;
    const body = `<p>Are you sure you want to delete the rule: <strong>${this.state.name}</strong>?</p>`;
    const buttonTextDefault = `Delete Rule`;
    const buttonTextLoading = `Deleting Rule`;
    const iconClass = `fa-trash-o`;
    const $modal = util.renderModal(
      title,
      body,
      buttonTextDefault,
      buttonTextLoading,
      iconClass
    );
    const $confirmButton = $modal.find(`.btn-danger`);

    // attach temporary event to remove the rule on confirmation of the modal;
    // remove any previous events first;
    // dont namespace the event because we want to remove everything;
    $confirmButton.one(`click`, () => {
      $confirmButton.button(`loading`);

      util
        .deleteRule(this.state.id)
        .fail(() => {
          setTimeout(() => {
            // reset the button on fail so it can be clicked again;
            $confirmButton.button(`reset`);
          }, util.delayForm);
        })
        .then(() => {
          // once done, go back to the list of rules
          $modal.modal(`hide`);
          browserHistory.push(`/rules/`);
        });
    });

    // attach the modal to the DOM, and then show it;
    jQuery(`body`).append($modal);
    $modal.modal(`show`);
  }

  // delete the exception associated with this rule;
  deleteException(exception) {
    const title = `Delete Exception to the Rule`;
    const body = `<p>Are you sure you want to delete the <strong>${moment(
      exception.start_date
    ).format(
      util.dateFormatHumanLong
    )}</strong> @ <strong>${util.returnCleanTimeSlot(
      exception.timeslot
    )}</strong> exception?</p>`;
    const buttonTextDefault = `Delete the Exception`;
    const buttonTextLoading = `Deleting the Exception`;
    const iconClass = `fa-trash-o`;
    const $modal = util.renderModal(
      title,
      body,
      buttonTextDefault,
      buttonTextLoading,
      iconClass
    );
    const $confirmButton = $modal.find(`.btn-danger`);

    // remove the exception on confirmation of the modal;
    $confirmButton.one(`click`, () => {
      $confirmButton.button(`loading`);

      util
        .deleteExceptionFromRule(exception.id)
        .fail(() => {
          setTimeout(() => {
            // reset the button on fail so it can be clicked again;
            $confirmButton.button(`reset`);
          }, util.delayForm);
        })
        .then(() => {
          // then load the rule again (to update state);
          this.getRule(() => {
            $modal.modal(`hide`);
          });

          // and update the conflict count;
          window.updateConflictCount();
        });
    });

    // attach the modal to the DOM, and then show it;
    jQuery(`body`).append($modal);
    $modal.modal(`show`);
  }

  // tell the back-end to change the end_date to yesterday;
  expireRule() {
    const title = `Expire Rule`;
    const body = `<p>Are you sure you want to expire the rule?</p>`;
    const buttonTextDefault = `Expire the Rule`;
    const buttonTextLoading = `Expiring the Rule`;
    const iconClass = `fa-calendar-times-o`;
    const $modal = util.renderModal(
      title,
      body,
      buttonTextDefault,
      buttonTextLoading,
      iconClass
    );
    const $confirmButton = $modal.find(`.btn-danger`);

    // remove the exception on confirmation of the modal;
    $confirmButton.one(`click`, () => {
      $confirmButton.button(`loading`);

      util
        .saveRuleAsExpired(this.state.id)
        .fail(() => {
          setTimeout(() => {
            // reset the button on fail so it can be clicked again;
            $confirmButton.button(`reset`);
          }, util.delayForm);
        })
        .then(() => {
          // then load the rule again (to update state);
          this.getRule(() => {
            $modal.modal(`hide`);
          });

          // and update the conflict count;
          window.updateConflictCount();
        });
    });

    // attach the modal to the DOM, and then show it;
    jQuery(`body`).append($modal);
    $modal.modal(`show`);
  }
}

RuleDetail.propTypes = {
  params: PropTypes.object
};
